<template>
  <wgu-map-overlay
    overlayId="tooltip-kanal"
    :visible=false
    autoPan
    :autoPanDuration="250"
    :offset="[0, 25]"
    positioning="top-center"
  >
    <template v-slot="{feature}">
<v-card
      width="auto"
      v-if="feature"
      style='border: 1px solid #0061a0;'
      >
    <v-btn
      elevation="1"
      color="#0061a0"
      icon
      class="ma-1"
      size="x-small"
      style="float:right;
      vertical-align: top;"
      @click="closeTooltip()"
    >
    <v-icon>md:close</v-icon>
    </v-btn>
      <!-- <v-img src="static/icon/damagepotential.jpg" height="100"/> -->
      <v-card-title>
        <span class="font-weight-thin">
          {{ $t('tooltips.kanal.titel') }}
        </span >
      </v-card-title>
      <v-card-subtitle class="my-2" style="font-size: large;">

            <span class="font-weight-bold">
              {{ $t('tooltips.kanal.entnahme') }}: {{ feature.get('entnahme') ? parseInt(feature.get('entnahme')).toLocaleString() + ' kW' : '' }}
            </span>
      </v-card-subtitle>
    </v-card>
</template>
  </wgu-map-overlay>
</template>

<script>
import MapOverlay from '../../src/components/modulecore/MapOverlay.vue'
import { WguEventBus } from '../../src/WguEventBus'
export default {
  name: 'tooltip-kanal',
  components: {
    'wgu-map-overlay': MapOverlay
  },
  methods: {
    closeTooltip () {
      WguEventBus.$emit('tooltip-kanal-update-overlay', false);
    }
  }
}
</script>
<style lang="css" scoped>

table {
    table-layout : fixed;
}
td {
    padding: 0 5px;
}

</style>
